<div class="order-review-component">
  <app-checkout-ship-to-rdd
    [shipToObj]="shiptoObj"
    [isOrderPlaced]="false"
  ></app-checkout-ship-to-rdd>
</div>
<div class="checkout-body-component">
  <app-checkout-order-list [cartData]="cartData"></app-checkout-order-list>
  <app-checkout-order-summary
    [cartData]="cartData"
  ></app-checkout-order-summary>
</div>
